const SEPARATOR = ' · ';

/**
 * Builds the standard organization header title in the form `"{tag} · {role}"`,
 * omitting either side when its label is missing.
 *
 * Used both as the NavigationBar subTitle (OrganizationDetailScreen) and as a
 * body heading (ProfileSettingScreen) so the wording stays consistent across
 * screens.
 */
export const formatOrganizationHeaderTitle = (
  tagLabel: string | undefined,
  roleLabel: string | undefined
): string | undefined => {
  if (!tagLabel && !roleLabel) return undefined;
  return [tagLabel, roleLabel].filter(Boolean).join(SEPARATOR);
};

export type OrganizationHeaderTitleInput = {
  tagLabel?: string | undefined;
  roleLabel?: string | undefined;
};

/**
 * Builds the standard organization header title in the form `"{tag} · {role}"`,
 * omitting either side when its label is missing. The role label may originate
 * from a per-organization role (`ADMIN`/`FUNKER`) or a global role.
 *
 * Used both as the NavigationBar subTitle (OrganizationDetailScreen) and as a
 * body heading (ProfileSettingScreen) so the wording stays consistent across
 * screens.
 */
export const buildOrganizationHeaderTitle = ({
  tagLabel,
  roleLabel
}: OrganizationHeaderTitleInput = {}): string | undefined =>
  formatOrganizationHeaderTitle(tagLabel, roleLabel);
